/**
 * Lift Google badge + Shopify Inbox above the mobile sticky ATC bar.
 * Sets --shopify-chat-activator-offset and mirrors badge bottom.
 * sync-bust: 2026-08-03-float-clear
 */
(function () {
  if (window.__mdbPdpFloatClear) return;
  window.__mdbPdpFloatClear = true;

  var BASE_CHAT_OFFSET = 80;

  function chatNode() {
    var host = document.querySelector('shopify-chat');
    if (host) {
      try {
        if (host.shadowRoot) {
          var inner =
            host.shadowRoot.querySelector('[part="button"], button, [role="button"], a') ||
            host.shadowRoot.querySelector('[class*="activator"], [class*="launcher"], [class*="button"]');
          if (inner) return inner;
        }
      } catch (e) {}
      return host;
    }
    return document.querySelector('#shopify-chat, [id*="ShopifyChat"]');
  }

  function stickyClearPx() {
    var bar = document.querySelector('.mdb-pdp-sticky-atc.is-visible');
    if (!bar || window.matchMedia('(min-width: 990px)').matches) return 0;
    var h = Math.ceil(bar.getBoundingClientRect().height);
    return h > 0 ? h + 8 : 0;
  }

  function apply() {
    var root = document.documentElement;
    var clear = stickyClearPx();
    root.style.setProperty('--mdb-pdp-chat-base-offset', BASE_CHAT_OFFSET + 'px');
    root.style.setProperty('--mdb-pdp-sticky-clear', clear ? clear + 'px' : '0px');

    var offset = BASE_CHAT_OFFSET + clear;
    root.style.setProperty('--shopify-chat-activator-offset', offset + 'px');

    var badge = document.querySelector('[data-mdb-g-badge], .mdb-g-badge');
    if (badge) {
      badge.style.setProperty('bottom', offset + 'px', 'important');
    }

    /* Nudge Inbox host if present (theme setting may also read the CSS var). */
    var chat = chatNode();
    if (chat && chat.style) {
      try {
        chat.style.setProperty('bottom', offset + 'px', 'important');
      } catch (e) {}
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      apply();
    });
  }

  function boot() {
    apply();
    var tries = 0;
    var tick = setInterval(function () {
      apply();
      tries += 1;
      if (tries > 48) clearInterval(tick);
    }, 250);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(schedule).observe(document.documentElement, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'style', 'aria-hidden'],
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
